import React from 'react'
import { useRecoilValue } from 'recoil'

import { H3 } from '@hub/heading'
import { Stack } from '@hub/stack'
import { Text } from '@hub/text'
import { Link } from '@hub/link'

import { Button } from '../button'
import { userAtom } from '../../lib/atoms/user-info'
import NumberPlates from './number-plates'
import FreeParkingGuide from './free-parking-guide'
import { FAQS_WESTFIELD_MEMBERSHIP } from '@scentregroup/shared/constants/paths'

const Parking: React.FC<React.PropsWithChildren<unknown>> = () => {
  const user = useRecoilValue(userAtom)
  const vehicles = user.data?.parkingProfile?.vehicles ?? []
  const isParkPlus =
    user.data?.isParkPlus &&
    !user.data?.westfieldPlus?.parkPlusTransitionAcceptedAt &&
    !user.data?.westfieldPlus?.parkPlusTransitionRejectedAt
  const showPlates = vehicles.length > 0 && !isParkPlus

  return (
    <>
      <H3
        sx={{
          marginBottom: 'spacing-lg',
        }}
      >
        Parking
      </H3>
      <Stack gap={'spacing-md'}>
        <Text
          sx={{
            fontSize: 'font-sm',
            lineHeight: 'base',
            marginBottom: 'spacing-sm',
          }}
        >
          As a Westfield member, you can get more free parking at selected
          centres, track your parking time, and set reminders using the
          Westfield app.
        </Text>

        {showPlates ? (
          <NumberPlates vehicles={vehicles} />
        ) : (
          <FreeParkingGuide />
        )}
        <Button
          as={'a'}
          href={`${process.env.NEXT_PUBLIC_WEBSITE_CLIENT_URL}/westfield-plus/parking`}
          size={'md'}
          wordWrap={'break-word'}
          whiteSpace={'normal'}
          textAlign={'center'}
        >
          Go to Westfield App
        </Button>
        <Text fontSize={'font-sm'} lineHeight={'base'}>
          Need some help? Check out our parking{' '}
          <Link href={FAQS_WESTFIELD_MEMBERSHIP} hasUnderline={true}>
            FAQs
          </Link>
        </Text>
      </Stack>
    </>
  )
}

export default Parking
